export default __webpack_public_path__ + "static/media/yoy.22febe85.jpg";